import React from "react";

const Documents = () => {
  return (
    <section className="grid-section">
      <div className="grid-container">
        <h2>Documents is not currently available.</h2>
      </div>
    </section>
  );
};

export default Documents;
